import { enableRipple } from '@syncfusion/ej2-base'
enableRipple(true);

import { SidebarPlugin } from '@syncfusion/ej2-vue-navigations'
Vue.use(SidebarPlugin);

import { GridPlugin } from '@syncfusion/ej2-vue-grids'
Vue.use(GridPlugin);

import { ButtonPlugin, CheckBoxPlugin, RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons'
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(RadioButtonPlugin);

import { TextBoxPlugin, UploaderPlugin, FormValidator } from '@syncfusion/ej2-vue-inputs'
window.FormValidator = FormValidator;

Vue.use(TextBoxPlugin);
Vue.use(UploaderPlugin);

import { AutoCompletePlugin, MultiSelectPlugin, DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns'
Vue.use(AutoCompletePlugin);
Vue.use(MultiSelectPlugin);
Vue.use(DropDownListPlugin);

import { ToastPlugin } from '@syncfusion/ej2-vue-notifications'
Vue.use(ToastPlugin)